import { render } from "./OrganizeMatch.vue?vue&type=template&id=4a617851"
import script from "./OrganizeMatch.vue?vue&type=script&lang=js"
export * from "./OrganizeMatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__